export const HOME = {
  emergentLink: 'home-emergent-link',
  videoGrid: 'home-video-grid',
  videoCard: 'home-video-card',
  liveSection: 'home-live-section'
};

export const AUTH = {
  loginForm: 'auth-login-form',
  registerForm: 'auth-register-form',
  phoneInput: 'auth-phone-input',
  passwordInput: 'auth-password-input',
  submitButton: 'auth-submit-button',
  photoUpload: 'auth-photo-upload'
};

export const VIDEO = {
  player: 'video-player',
  playButton: 'video-play-button',
  buyButton: 'video-buy-button',
  priceTag: 'video-price-tag'
};

export const PAYMENT = {
  modal: 'payment-modal',
  methodSelect: 'payment-method-select',
  phoneInput: 'payment-phone-input',
  confirmButton: 'payment-confirm-button'
};

export const ADMIN = {
  dashboard: 'admin-dashboard',
  userTable: 'admin-user-table',
  statsCard: 'admin-stats-card',
  uploadForm: 'admin-upload-form'
};

export const LIVE = {
  player: 'live-player',
  chatBox: 'live-chat-box',
  sendButton: 'live-send-button',
  liveBadge: 'live-badge'
};